import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { SaveSimulationService } from '@apiShared/hubspot/save-simulation.service';
import { Globals } from '@config/global';
import { NotificacionService } from '@utils/notificacion';
import { getDataSaveSimulation } from './get-data-save-simulation';
import { isPlatformBrowser, Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { CookieUtil } from '@utils/cookies';
import { AcquisitionChannelUtil } from '@utils/acquisition-channel.util';
import { UtilsMethods_Services } from '@utils/utils';
import { RedirectUsersMarketingResponseI } from '@interface/redirect-users-marketing.interface';

@Injectable({
  providedIn: 'root',
})
export class HubspotSimulation_Helper {
  allowedQueryParams = [
    'medio',
    'accion',
    'campana',
    'director',
    'anuncios',
    'detalle',
    'ref',
    'bono',
    'valor_cdt_regalo',
    'asesor',
  ];

  constructor(
    public globals_var: Globals,
    private utils: UtilsMethods_Services,
    private cookies: CookieUtil,
    private notification: NotificacionService,
    private apiSaveSimulation_Hubspot: SaveSimulationService,
    private set_data_save_simulation: getDataSaveSimulation,
    private route: ActivatedRoute,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {}

  /**
   * @description Enriquece el objeto data con información de query parameters
   * @param data Objeto base de datos
   * @returns Objeto data enriquecido con query parameters
   */
  private enrichDataWithQueryParams(data: any): any {
    if (!isPlatformBrowser(this.platformId)) {
      return data;
    }

    const queryParams = this.route.snapshot.queryParams;

    this.allowedQueryParams.forEach((param) => {
      if (queryParams[param]) {
        data[param] = queryParams[param].replaceAll('_', ' ');
      }
    });

    return data;
  }

  HUBSPOT_SIMULATION(body: any) {
    if (isPlatformBrowser(this.platformId)) {
      let ignorePath: boolean = true;
      let pathWithQueryParams: boolean = false;
      let isPathOfPautaMKT: RedirectUsersMarketingResponseI = this.utils.validatePautaMarketingParams(
        ignorePath,
        pathWithQueryParams,
      );
      let data: any = {
        amnt: body.amount,
        phone: body.phone,
        name: body.name,
        srcurl: document.referrer,
        urlpdf: body.urlpdf,
        platform: 'web',
      };

      // Si viene de Pauta MKT, agregar las propiedades correspondientes
      if (isPathOfPautaMKT.url_valid) {
        data.pauta = isPathOfPautaMKT.path;
      }

      data = this.enrichDataWithQueryParams(data);

      if (body.bankname === this.globals_var.FLAMINGO) {
        data.external_company = this.globals_var.FLAMINGO;
      }

      if (data?.ref === 'claudiauribe') {
        data.external_company = this.globals_var.CAMPAIGN_CLAUDIAURIBE;
      }

      if (body.adv) {
        data.adv = body.adv;
      }

      if (this.cookies.check('acq_chn')) {
        data.acquisition_channel = this.cookies.get('acq_chn');
      }

      return this.apiSaveSimulation_Hubspot.POST_SIMULATION_HUBSPOT(data).subscribe((data: any) => {
        this.notification.sendNotificacion({
          api: 'api-notification-data-save-simulation',
          data: data,
        });
        this.set_data_save_simulation.setData(data);
      });
    }

    return '';
  }
}
